import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private count = 0;
  private lockedScrollY = 0;
  private scrollLocked = false;
  private spinners$ = new BehaviorSubject<string>('');
  constructor() {}

  getSpinnerObservable(): Observable<string> {
    return this.spinners$.asObservable();
  }

  requestStarted() {
    if (++this.count === 1) {
      this.spinners$.next('start');
      this.lockScroll();
    }
  }

  requestEnded() {
    if (this.count === 0 || --this.count === 0) {
      this.spinners$.next('stop');
      this.unlockScroll();
    }
  }

  resetSpinner() {
    this.count = 0;
    this.spinners$.next('stop');
    this.unlockScroll();
  }

  private lockScroll(): void {
    if (this.scrollLocked || typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }
    this.scrollLocked = true;
    this.lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  private unlockScroll(): void {
    if (!this.scrollLocked) {
      return;
    }
    this.scrollLocked = false;
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this.lockedScrollY);
    this.lockedScrollY = 0;
  }
}
